export default "__VITE_ASSET__17d65b5b__"